import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import theme from 'styles/theme';

export const ReviewDetailsHeader = styled.div`
  span {
    font-size: 16px;
    color: ${theme.colors.bgGreen};
    margin-bottom: 14px;
    text-transform: uppercase;
    font-weight: 600;
  }

  h2 {
    font-size: 30px;
    font-weight: 500;
    margin: 0;
    color: ${theme.colors.hostfullyBlue};
    font-weight: 600;
  }

  margin-bottom: 12px;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${theme.colors.gray300};
  margin: 20px 0 48px 0;
`;

export const Disclaimer = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${theme.colors.gray600};
  text-align: center;
  margin-top: 32px;

  padding: 0 200px;

  ${mediaQuery.sm} {
    padding: 0 48px;
  }
`;
